var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "currentColor",
    viewBox: "0 0 97.75 97.75"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.875 0C21.882 0 0 21.882 0 48.875S21.882 97.75 48.875 97.75 97.75 75.868 97.75 48.875 75.868 0 48.875 0M30.562 81.966h-13.74V37.758h13.74zm-6.867-50.251a7.97 7.97 0 0 1-7.969-7.968 7.97 7.97 0 0 1 7.969-7.964c4.392 0 7.962 3.57 7.962 7.964 0 4.399-3.571 7.968-7.962 7.968m58.328 50.251H68.294V60.467c0-5.127-.095-11.721-7.142-11.721-7.146 0-8.245 5.584-8.245 11.35v21.869H39.179V37.758h13.178v6.041h.185c1.835-3.476 6.315-7.14 13-7.14 13.913 0 16.481 9.156 16.481 21.059z"
  })));
};
export default SvgLinkedin;